import React, { useEffect } from "react";

const useMediaQuery = (query) => {
  const [matches, setMatches] = React.useState(false);
  useEffect(() => {
    const matchQueryList = window.matchMedia(query);


    if (matchQueryList) setMatches(matchQueryList.matches);

    function handleChange(e) {
      setMatches(e.matches);
    }

    matchQueryList.addEventListener("change", handleChange);
    return () => {
      matchQueryList.removeEventListener("change", handleChange);
    };
  }, [query]);
  return matches;
};

export default useMediaQuery;



// WEBPACK FOOTER //
// ./src/js/hooks/useMediaQuery.js